// Mock data for The Favor website

export const bundles = [
  {
    id: 1,
    name: "The Mini Favor",
    description: "All the party charm without the extra spend",
    includes: [
      "1 custom chip bag OR candy wrapper",
      "1 matching favor tag",
      "1 sticker design"
    ],
    digitalPrice: 35,
    printedPrice: 60,
    category: "party",
    popular: false,
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80"
  },
  {
    id: 2,
    name: "The Party Starter",
    description: "Most popular.",
    includes: [
      "Chip bags or candy wrappers (2 designs)",
      "Water bottle wrap",
      "Favor tags",
      "Welcome sign (8x10 or poster)",
      "Matching stickers"
    ],
    digitalPrice: 75,
    printedPrice: 187,
    category: "party",
    popular: true,
    image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80"
  },
  {
    id: 3,
    name: "The Full Celebration",
    description: "One bundle, every detail, total peace of mind.",
    includes: [
      "Full favor set (chip bags, candy wrappers, toppers)",
      "Water bottle wraps",
      "Welcome sign",
      "Activity or coloring sheet",
      "Stickers",
      "Coordinated theme"
    ],
    digitalPrice: 125,
    printedPrice: 337,
    category: "party",
    popular: false,
    image: "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=800&q=80"
  },
  {
    id: 4,
    name: "The Signature Experience",
    description: "Weddings. Milestone events.",
    includes: [
      "Everything in Full Celebration",
      "Custom poster or backdrop design",
      "Seating chart or large signage",
      "Game or keepsake"
    ],
    digitalPrice: 225,
    printedPrice: 700,
    category: "premium",
    popular: false,
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80"
  },
  {
    id: 5,
    name: "Wedding Essentials Bundle",
    description: "Everything you need for your special day.",
    includes: [
      "Invitation",
      "Details card",
      "RSVP",
      "Seating chart",
      "Welcome sign"
    ],
    digitalPrice: 250,
    printedPrice: 900,
    category: "wedding",
    popular: false,
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80"
  },
  {
    id: 6,
    name: "Wedding Luxe Bundle",
    description: "The complete luxury wedding experience.",
    includes: [
      "Everything in Wedding Essentials",
      "Programs",
      "Table numbers",
      "Favor tags",
      "Bar menu"
    ],
    digitalPrice: 400,
    printedPrice: 1600,
    category: "wedding",
    popular: false,
    image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=800&q=80"
  }
];

export const occasions = [
  {
    id: 1,
    name: "Birthday Parties",
    icon: "Cake",
    image: "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=600&q=80"
  },
  {
    id: 2,
    name: "Weddings & Stationery",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600&q=80"
  },
  {
    id: 3,
    name: "Bachelorette & Bridal",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600&q=80"
  },
  {
    id: 4,
    name: "Baby & Kids",
    icon: "Baby",
    image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=600&q=80"
  },
  {
    id: 5,
    name: "Seasonal & Holiday",
    icon: "Snowflake",
    image: "https://images.unsplash.com/photo-1512389142860-9c449e58a543?w=600&q=80"
  },
  {
    id: 6,
    name: "Custom Requests",
    icon: "Sparkle",
    image: "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=600&q=80"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Choose a Collection or Bundle",
    description: "Browse our curated bundles designed for every occasion."
  },
  {
    step: 2,
    title: "Customize Your Details",
    description: "Share your vision and we'll tailor every element to match."
  },
  {
    step: 3,
    title: "Receive Digital Files or Printed Goods",
    description: "Get ready-to-use files or beautifully printed materials."
  },
  {
    step: 4,
    title: "Celebrate in Style",
    description: "Bring your event to life with cohesive, custom details."
  }
];

export const whyTheFavor = [
  "Fully custom designs",
  "Cohesive party styling",
  "Digital + print options",
  "Designed with intention"
];